(function() {
  function initCarousel() {
    var section = document.querySelector('#shopify-section-template--30638652424529__carousel_HQxWi6');
    if (!section) return;

    var track = section.querySelector('slideshow-slides');
    if (!track) return;

    // Clone items for seamless loop
    var items = Array.from(track.children);
    if (items.length === 0) return;
    items.forEach(function(item) {
      track.appendChild(item.cloneNode(true));
    });

    track.style.cssText += 'display:flex!important;flex-wrap:nowrap!important;will-change:transform;overflow:visible!important;';

    // Also make the parent overflow hidden to clip the scrolling
    var container = section.querySelector('slideshow-component, slideshow-container');
    if (container) container.style.overflow = 'hidden';

    var pos = 0;
    var speed = 3;
// Force small font on card text
function updateFontSizes() {
  var isMobile = window.innerWidth <= 749;
  section.querySelectorAll('.card p, .card [class*="text"]').forEach(function(el) {
    el.style.setProperty('font-size', isMobile ? '10px' : '14px', 'important');
    el.style.setProperty('line-height', isMobile ? '1.1' : '1.4', 'important');
  });
}
updateFontSizes();
window.addEventListener('resize', updateFontSizes);
    function animate() {
      pos -= speed;
      var half = track.scrollWidth / 2;
      if (Math.abs(pos) >= half) pos = 0;
      track.style.transform = 'translateX(' + pos + 'px)';
      requestAnimationFrame(animate);
    }
    requestAnimationFrame(animate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousel);
  } else {
    setTimeout(initCarousel, 500);
  }
})();